import React from 'react';
import reserveSeatsInBulk from '../../../utils/functions/booking/reserveSeatsInBulk';

function CoupeReserve({
  availableSeats, seats, wagonNumber, unReserveSeat, reserveSeat,
}) {
  return !!availableSeats?.length && (
    <button
      type="button"
      onClick={() => reserveSeatsInBulk({
        availableSeats,
        seats,
        reserveSeat,
        unReserveSeat,
        wagonNumber,
      })}
      className="absolute left-1/2 top-[-30px] translate-x-1/2 p-0 m-0 border-none bg-transparent cursor-pointer"
    >
      <img src="/wagon-icons/coupe.webp" alt="Coupe" width={27} height={18} className="object-fit" />
    </button>
  );
}

export default CoupeReserve;
